import ListBox from '@ingka/list-box';
import ListView from '@ingka/list-view';
import { selectOrderType } from '@repo/api-adapters/selectors/customer-assets.selectors';

import { useAsset, useAssetParams } from '@/hooks/asset.hooks';

import { ACTION_BUTTONS_CONFIG, ASSET_ACTIONS_CONFIG } from '../../status-header.config';
import { getComponentConfig } from '../asset-context-buttons.utils';

import styles from './styles.module.scss';

interface Props {
    visible: boolean;
    onClose: () => void;
}

export const AssetContextDropdown = ({ visible, onClose }: Props) => {
    const { assetType, assetId } = useAssetParams();
    const { data } = useAsset(assetType, assetId);

    if (!data) {
        return null;
    }

    const orderType = selectOrderType(data);
    const buttonsConfig = getComponentConfig(ASSET_ACTIONS_CONFIG, assetType, orderType);

    if (!buttonsConfig) {
        return null;
    }

    return (
        <ListBox className={String(styles.ellipses_dropdown)} data-testid="ellipses-dropdown-box" open={visible}>
            <ListView id="asset-header-dropdown-container" showDivider={false} size="small">
                {buttonsConfig.map((key) => {
                    const ActionComponent = ACTION_BUTTONS_CONFIG[key];
                    if (!ActionComponent) {
                        return null;
                    }

                    return <ActionComponent key={key} onClose={onClose} context="dropdown" type="listitem" />;
                })}
            </ListView>
        </ListBox>
    );
};
